<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="page_i"></a>LIGHTNINGS</p>
<p class="half1">TO <span class="half">SPITFIRES</span></p>
<p class="halftit">MEMOIRS OF AN RAF FIGHTER PILOT AND FORMER</p>
<p class="halftit1">OFFICER COMMANDING THE BATTLE OF BRITAIN</p>
<p class="halftit1">MEMORIAL FLIGHT</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle.vue?41cac40d